import { baseApi } from 'services/baseApi';
import { Item } from 'types';
import {
  PartnerAccess,
  PartnerAccessesParams,
  PartnerParams,
  PartnerTFAStateParams,
} from 'app/resource/types/partner';
import { AppConstants } from 'constants/index';
import { cacheTags } from 'constants/cacheTags';

export const partner = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResourcePartner: builder.query<Item, PartnerParams>({
      query: ({ skipGlobalLoading, partnerId }) => {
        const {
          ReportingAdmin, Resource, Partner,
        } = AppConstants.api;
        return {
          url: [ReportingAdmin, Resource, Partner, partnerId],
          meta: { skipGlobalLoading },
        };
      },
      providesTags: [cacheTags.ResourcePartner],
    }),
    getResourcePartnerTFAState: builder.query<boolean, PartnerTFAStateParams>({
      query: ({ skipGlobalLoading, partnerId }) => {
        const {
          ReportingAdmin, Resource, TFAStatus,
        } = AppConstants.api;
        return {
          url: [ReportingAdmin, Resource, TFAStatus, partnerId],
          meta: { skipGlobalLoading },
        };
      },
      providesTags: [cacheTags.ResourcePartnerTFAState],
    }),
    getResourcePartnerAccesses: builder.query<PartnerAccess[], PartnerAccessesParams>({
      query: ({ skipGlobalLoading, partnerId }) => {
        const {
          Admin, Partner, PartnerAccesses,
        } = AppConstants.api;
        return {
          url: [Admin, Partner, PartnerAccesses, partnerId],
          meta: { skipGlobalLoading },
        };
      },
      providesTags: [cacheTags.ResourcePartnerAccesses],
    }),
  }),
});

export const {
  useGetResourcePartnerQuery, useGetResourcePartnerTFAStateQuery, useGetResourcePartnerAccessesQuery,
} = partner;
